import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Domains from './components/Domains';
import Zwacop from './components/Zwacop';
import EdenManager from './components/EdenManager';
import Tracking from './components/Tracking';
import Services from './components/Services';
import Agriculture from './components/Agriculture';
import Vision from './components/Vision';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Zwacop />
        <EdenManager />
        <Tracking />
        <Projects />
        <Domains />
        <Agriculture />
        <Vision />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;